import { Popover, Tag } from "antd"
import { ReactComponent as DELETE } from "../../../assets/DeleteICON.svg"
import { ReactComponent as HOUSE } from "../../../assets/HouseICON.svg"
import { ReactComponent as PEOPLE } from "../../../assets/People.svg"
import { P } from "../../../auth/permissions"
import { Authorized } from "../../../components/authentication/Authorized"
import { Tour } from "../types"
import TourWeekdayStrip from "./TourWeekdayStrip"

type TourCardType = {
    tour: Tour
    onOpen: () => void
    onDelete: (id: string) => void
}

export default function TourCard(props: TourCardType) {
    const employeeName = props.tour.employee ? `${props.tour.employee.first_name} ${props.tour.employee.last_name}` : "Nicht zugewiesen"

    return (
        <div className={`w-full h-fit rounded-default shadow-lg flex flex-col px-4 pt-4 pb-6 bg-white relative ${!props.tour.active ? "text-gray-400 opacity-60" : ""}`}>
            <div className="flex items-center justify-between gap-2 border-b mb-4 pb-1 px-2">
                <h3 title={props.tour.name} className="text-lg 2xl:text-xl font-semibold truncate">
                    {props.tour.name}
                </h3>
                <Tag className="m-0 shrink-0" color={props.tour.active ? "green" : "default"}>
                    {props.tour.active ? "Aktiv" : "Pausiert"}
                </Tag>
            </div>

            <div className="flex items-start gap-6 px-2">
                <div className="flex flex-row min-w-0">
                    <PEOPLE className="w-6 h-6 shrink-0" />
                    <p title={employeeName} className="pl-2 text-sm 2xl:text-base line-clamp-1">
                        {employeeName}
                    </p>
                </div>
                <div className="flex flex-row shrink-0">
                    <HOUSE className="w-6 h-6 shrink-0" />
                    <p className="pl-2 text-sm 2xl:text-base whitespace-nowrap">{props.tour.stops.length} Objekte</p>
                </div>
            </div>

            <div className="px-2 mt-5">
                <TourWeekdayStrip tour={props.tour} />
            </div>

            <Authorized allOf={[P.termine_management]}>
                <div className="flex flex-row justify-end items-center z-10 mt-5" onClick={(event) => event.stopPropagation()}>
                    <Popover
                        placement="bottomLeft"
                        title="Löschen?"
                        content={
                            <div className="flex flex-col items-end">
                                <p>Wollen Sie diese Tour wirklich entfernen?</p>
                                <button className="btn btn-sm btn-error mt-2" onClick={() => props.onDelete(props.tour._id)}>
                                    Löschen
                                </button>
                            </div>
                        }>
                        <DELETE className="w-6 h-6 cursor-pointer hover:text-error" />
                    </Popover>
                </div>
            </Authorized>
            <div onClick={props.onOpen} className="w-full h-full absolute top-0 left-0 cursor-pointer" />
        </div>
    )
}
